module.exports = __webpack_public_path__ + "static/media/HKGrotesk-SemiBold.cc915f36.ttf";